// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ip","placeholder":"e_jp","embed":"e_kp"};